import React from "react";
import { hexToRgba } from "../../../services/helpFunctions/hexToRgba";

// Pulls a #rrggbb out of a plain hex or a "var(--x, #rrggbb)" token.
const extractHex = (c) => {
  const m = /#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/.exec(c || "");
  return m ? m[0] : "#707073";
};

// Tinted status pill matching the platform's in-table status style
// (coloured dot + label on a light tint of the same colour).
const StatusPill = ({ text, fill = "#707073" }) => {
  const hex = extractHex(fill);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 10px",
        borderRadius: 16,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.6,
        color: hex,
        background: hexToRgba(hex, 0.12),
        whiteSpace: "nowrap",
      }}
    >
      <svg width="8" height="8" viewBox="0 0 9 9">
        <circle cx="4.5" cy="4.27" r="4" fill={hex} />
      </svg>
      {text}
    </span>
  );
};

export default StatusPill;
